import createRoute        from '@widesk-ui/tools/createRoute';
import ScheduleGroupModel from '@models/shop/ScheduleGroupModel';

export default createRoute.splitView('/schedule_groups', 'shop', 'ScheduleGroupSplitView', ScheduleGroupModel.localize('plural'));
